<template>
  <div class="home py-5">
		<span class="d-flex flex-row page-title">{{$t("intranet.title.page.announcement.list")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAnnouncementList :APIbaseURL="APIbaseURL" :announcements="this.announcements" :adminMode="true"/>
      <div class="text-center">
        <v-pagination
          v-model="currentPage"
          :length="paginationLength"
          :total-visible="paginationLength < 7 ? paginationLength : 7"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAnnouncementList } from 'aveine-changelog'
import { Announcement } from 'aveine-toolbox'
import { marked } from 'marked';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      announcements: [],
      componentFilter: null,
      currentPage: this.$route.query.page,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },

  name: 'Index',
  components: {
    AveineAnnouncementList
  },
  
  async mounted() {
    this.loadAnnouncements();
  },
  methods: {
    async loadAnnouncements (componentFilter) {
      try {
        this.announcements = [];
        this.dataLoaded = false;
        
        let params =  
        {
          "sort": "-created-at",
          "page[number]": this.$route.params.page || 1,
          "page[size]": 50,
        };

        if (componentFilter)
          params["filter[component]"] = componentFilter

        let announcements = await Announcement.api().get(`announcements?lang=${this.$i18n.locale}`, {
            baseURL: this.APIbaseURL,
            params
          }
        );

        const that = this;
        announcements.response.data.map(async function(data){
          let announcement = await Announcement.query().whereId(data.id).withAllRecursive().first();
          Object.keys(announcement.markdown).map(function(lang){
            if (announcement.markdown[lang]) {
              announcement.markdown[lang] = marked(announcement.markdown[lang], { sanitize: true })
            }
          })
          that.announcements.push(announcement);
        })
        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  },
}
</script>
